import { SimNaoEnum } from 'components/form'

import { isAllNao } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta08ForaAlcanceEnum,
  ConsultaSeguimentoPergunta08Model,
} from './model-consultaSeguimentoPergunta08'

const pergunta08ForaAlcanceEnum = Object.values(ConsultaSeguimentoPergunta08ForaAlcanceEnum)

export const isPergunta08ForaAlcanceAllNao = (
  value: ConsultaSeguimentoPergunta08Model['PERGUNTA_08_FORA_ALCANCE']
): boolean => {
  return isAllNao(value, pergunta08ForaAlcanceEnum)
}

export function prunePergunta08(value: ConsultaSeguimentoPergunta08Model): ConsultaSeguimentoPergunta08Model {
  const pruned: ConsultaSeguimentoPergunta08Model = {
    status: value.status,
    resultado: value.resultado,
    PERGUNTA_08_HEADER: value.PERGUNTA_08_HEADER,
  }

  const isHeaderSim = value.PERGUNTA_08_HEADER === SimNaoEnum.SIM
  const isHeaderNao = value.PERGUNTA_08_HEADER === SimNaoEnum.NAO
  const isSeInteressaPorNao = value.PERGUNTA_08_SE_INTERESSA_POR === SimNaoEnum.NAO
  const isRespondePerguntasSim = value.PERGUNTA_08_RESPONDE_PERGUNTAS === SimNaoEnum.SIM
  const isNotForaAlcanceAllNao = !isPergunta08ForaAlcanceAllNao(value.PERGUNTA_08_FORA_ALCANCE)

  if (isHeaderSim) {
    pruned.PERGUNTA_08_SE_INTERESSA_POR = value.PERGUNTA_08_SE_INTERESSA_POR
  }

  if (isSeInteressaPorNao || isHeaderNao) {
    pruned.PERGUNTA_08_RESPONDE_PERGUNTAS = value.PERGUNTA_08_RESPONDE_PERGUNTAS

    if (isRespondePerguntasSim) {
      pruned.PERGUNTA_08_FORA_ALCANCE = value.PERGUNTA_08_FORA_ALCANCE

      if (isNotForaAlcanceAllNao) {
        pruned.PERGUNTA_08_RESPONDE_CRIANCAS = value.PERGUNTA_08_RESPONDE_CRIANCAS
      }
    }
  }

  return pruned
}
